"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var firestore_1 = require("firebase/firestore");
var react_redux_1 = require("react-redux");
var Autocomplete_1 = __importDefault(require("atomicComponents/organisms/Autocomplete"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var analytics_1 = require("utils/analytics");
var hooks_1 = require("utils/hooks");
var options_1 = require("utils/selectors/options");
var SimplifiedAutocomplete = (0, SimplifyFormInput_1.default)(Autocomplete_1.default);
var CustomerSelect = function (_a) {
    var item = _a.item;
    var sortedCustomers = (0, react_redux_1.useSelector)(options_1.selectRechargeCustomerOptions);
    var _b = __read((0, hooks_1.useSubmitter)('recharged_organizations', item.id), 2), rechOrgSubmitter = _b[0], isSending = _b[1];
    var track = (0, analytics_1.useTracker)();
    if (!sortedCustomers) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var handleChange = function (valObj) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(valObj === null)) return [3 /*break*/, 2];
                    track('Recharges Mapping Reverted', {
                        rechargedOrgId: item.id,
                        rechargedOrgName: item.name,
                        previousRechargedCustomerName: (_a = item.customer) === null || _a === void 0 ? void 0 : _a.name,
                        newRechargedCustomerName: '',
                        isSelectClear: true,
                    });
                    return [4 /*yield*/, rechOrgSubmitter({ customerId: (0, firestore_1.deleteField)(), matchStatus: 'none' })];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2:
                    if (!(valObj && 'value' in valObj && (valObj === null || valObj === void 0 ? void 0 : valObj.value))) return [3 /*break*/, 4];
                    track('Recharges Mapping Submitted', {
                        rechargedOrgId: item.id,
                        rechargedOrgName: item.name,
                        previousRechargedCustomerName: (_b = item.customer) === null || _b === void 0 ? void 0 : _b.name,
                        rechargedCustomerId: valObj === null || valObj === void 0 ? void 0 : valObj.value,
                        rechargedCustomerName: valObj === null || valObj === void 0 ? void 0 : valObj.label,
                    });
                    return [4 /*yield*/, rechOrgSubmitter({ customerId: valObj.value, matchStatus: 'confirmed', matchStatusSetOn: firestore_1.Timestamp.now() })];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4: return [2 /*return*/, valObj];
            }
        });
    }); };
    var onClear = function (e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        handleChange(null);
    };
    return ((0, jsx_runtime_1.jsx)(SimplifiedAutocomplete, { options: sortedCustomers, label: "Select a customer", placeholder: "Select a customer", onChange: handleChange, noOptionsText: "Customer not found", value: (item.customerId && (sortedCustomers === null || sortedCustomers === void 0 ? void 0 : sortedCustomers.find(function (opt) { return opt.value === item.customerId; }))) || { value: '', label: '' }, isDisabled: item.matchStatus !== 'none' || isSending, btnProps: { className: 'highlightInput', onClear: item.customerId ? onClear : undefined } }));
};
exports.default = CustomerSelect;
